/**
 * Core – translations used across all projects
 * Merges all core sections into one object
 */

import auth from "./auth.js";
import menu from "./menu.js";
import dashboard from "./dashboard.js";
import profile from "./profile.js";
import stores from "./stores.js";
import billing from "./billing.js";
import messages from "./messages.js";
import help from "./help.js";
import due from "./due.js";
import news from "./news.js";
import common from "./common.js";
import documentTemplate from "./documentTemplate.js";
import systemMessages from "./systemMessages.js";

export default {
  ...auth,
  ...menu,
  ...dashboard,
  ...profile,
  ...stores,
  ...billing,
  ...messages,
  ...help,
  ...due,
  ...news,
  ...common,
  ...documentTemplate,
  systemMessages,
};
